import * as React from 'react';
import { Layout } from '../Layout';
import { PageBlock } from '../PageBlock';

export const LayoutBlock: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <PageBlock>
      <Layout>{children}</Layout>
    </PageBlock>
  );
};
